import { ApolloLink, Observable } from "@apollo/client"

// Setup the header for the request
export const middlewareAuthLink = new ApolloLink((operation, forward) => {
    const token = localStorage.getItem(process.env.REACT_APP_SESSION_TOKEN_NAME)
    const authorizationHeader = token ?? null

    operation.setContext({
        headers: {
            authorization: authorizationHeader
        }
    })
    return forward(operation)
})

//After the backend responds, we take the authorization token from headers if it exists, and save it in the local storage.
export const afterwareLink = new ApolloLink((operation, forward) => {
    return new Observable(observer => {
        forward(operation).subscribe({
            next: res => {
                const context = operation.getContext()
                const { response } = context
                const { headers } = response

                 if(headers) {
                    const refreshToken = headers.get('authorization')
                    if(refreshToken) {
                        localStorage.setItem(process.env.REACT_APP_SESSION_TOKEN_NAME, refreshToken)
                    }
                }

                observer.next(res)
            },
            error: err => observer.error(err),
            complete: () => observer.complete(),
        })
    })
})